import React, { Component } from 'react';
import {Switch, Route} from 'react-router-dom'
import classnames from 'classnames';
import {Card, CardTitle, CardText} from 'material-ui/Card';
import {GridList, GridTile} from 'material-ui/GridList';
import {List, ListItem} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';
import {Tabs, Tab} from 'material-ui/Tabs';

import Phone from 'material-ui/svg-icons/communication/phone';
import Mail from 'material-ui/svg-icons/communication/email';
import Address from 'material-ui/svg-icons/communication/business';

import WorkExperience from './WorkExperience';
import Education from './Education';
import Publications from './Publications';
import Projects from './Projects';

/*<p>Researcher in Empirical Software Engineering based on Norway and Sweden. Over ten years of industrial experience, as a project manager and designer in companies developing web-based and client-server applications.</p>
<p>Interested in the following topics: research methodology, empirical software engineering (ESE), global software development (GSD), software process improvement (SPI), and gamification.</p>*/              

class Page extends Component {
  constructor(props) {
    super(props);

    this.changeTab = this.changeTab.bind(this);

    this.state = {
      tab: (this.props.location||{}).pathname
    };
  }

  changeTab(value) {
    this.setState({tab: value});

    this.props.history.push(value);
  }

  render() {
    const { className } = this.props;
    const h2Icon = {
      marginLeft: 24,
      marginRight: 24,
    };
    /*const uiTheme = {
      primaryColor: '#607d8b',
      primaryLightColor: '#8eacbb',
      primaryDarkColor: '#34515e',
      secondaryColor: '#448aff',
      secondaryLightColor: '#83b9ff',
      secondaryDarkColor: '#005ecb',
      primaryTextColor: '#ffffff',
      secondaryTextColor: '#ffffff',
    };*/

    return (
      <div className={classnames('container', className)}>
        <GridList
          cols={3}
          padding={10}
          cellHeight='auto'
        >
          <GridTile
            /* title = "Jefferson Molléri, PhD."
            subtitle = Associate Professor
            titlePosition = "top" */
            className={classnames('col l4 m12 s12 sidebar z-depth-1')}
          >
            <div className={classnames('heading')}>
              <div className={classnames('feature-img')}>
                <img src="/img/profile-img.JPG" width="100%" className={classnames('responsive-img')} alt="" />
              </div>
              <div className={classnames('title col s12 m12 l9')}>
                <h2>Jefferson Seide Molléri</h2>
                <span>Associate Professor</span>
              </div>
            </div>

            <List className={classnames('sidebar', className)}>
              <ListItem
                leftAvatar={<Avatar icon={<Mail />} backgroundColor='rgba(0,0,0,0)' />}
                primaryText={<a href="mailto:jefferson.molleri@gmail.com">jefferson.molleri@gmail.com</a>}
                secondaryText="e-mail"
                disabled="true"
              />
              <Divider inset={true} />
              <ListItem
                leftAvatar={<Avatar icon={<Phone />} backgroundColor='rgba(0,0,0,0)' />}
                primaryText="+47 4021 2262"
                secondaryText="mobile"
                disabled="true"

              />
              <Divider inset={true} />
              <ListItem
                leftAvatar={<Avatar icon={<Address />} backgroundColor='rgba(0,0,0,0)' />}
                primaryText={<span>Kristiania University College<br />SEIT - School of Economics, Innovation and Technology<br /></span>}
                secondaryText={<span>Kirkegata 23-25<br />0153 Oslo, Norway</span>}
                disabled="true"
              />
            </List>

          </GridTile>
          <GridTile cols="2">
            <Card>
              <CardTitle title="Summary" />
              <CardText>
                <p>Expert in evidence-based SE and empirical research methods, with a focus on improving software development practices through data-driven studies, AI applications, and process optimization.</p>
                <p>Key research areas include research quality, AI for software engineering (AI4SE), software process improvement (SPI), and human factors in SE, with additional interests in project management, human-computer interaction (HCI), and gamification.</p>
              </CardText>

              <Tabs onChange={this.changeTab} value={this.state.tab}>
                <Tab label="Work Experience" value="/home" />
                <Tab label="Education" value="/home/education" />
                <Tab label="Publications" value="/home/publications" />
                <Tab label="Projects" value="/home/projects"/>
              </Tabs>
              <br/>

              <Switch>
                <Route path="*/education" component={Education} />
                <Route path="*/publications" component={Publications} />
                <Route path="*/projects" component={Projects} />
                <Route path="*/" component={WorkExperience} />
              </Switch>
            </Card>
          </GridTile>
        </GridList>
      </div>
    );
  }
}

export default Page;


// WEBPACK FOOTER //
// ./src/components/Home/index.js